module.exports = __webpack_public_path__ + "img/competency-parts.10c0f8b0.jpg";